import type { Calculation } from './Calculation';
import type { Purchase } from './Purchase';

export enum OrientationType {
  MortgageIncrease = 'MortgageIncrease',
  Purchase = 'Purchase',
  InterestOnly = 'InterestOnly',
  Unknown = 'Unknown'
}

export enum OrientationStarter {
  HOStart = 'HOStart',
  HAStart = 'HAStart',
  AdvStart = 'AdvStart'
}

export interface Orientation {
  readonly mortgageIncreaseData?: Calculation;
  readonly purchaseData?: Purchase;
  readonly lastUpdate?: string;
  readonly type: OrientationType;
  readonly startedBy?: OrientationStarter;
}
